const mTheHeaderLicenseUpgrade = {
  mTheHeaderLicenseUpgrade: {
    upgrade: {
      firstText: 'ATENCIÓN: Alcanzaste el límite máximo de recursos, para aumentar las características de tu plan actual haz click en el siguiente enlace',
      linkText: 'actualizar plan.'
    }
  }
}

export default mTheHeaderLicenseUpgrade
